<template>
  <v-container fluid class="pa-0">
    <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
      <v-row no-gutters>
        <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
          <div class="d-flex grow flex-wrap">
            <div class="font-weight-regular headline text-decoration-underline text-capitalize">
              Role Configuration
            </div>
          </div>
        </v-col>
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'amsSchedulingDashboard' }">
            <v-btn
              elevation="1"
              absolute
              right
              top
            >
              <v-icon left>mdi-arrow-left</v-icon>back</v-btn
            >
          </router-link>
        </v-card-actions>
      </v-row>
      <v-row class="rowClass">
          <v-col
          cols="12"
          sm="6"
          md="4"
          lg="4"
        >
        <router-link
          :to="{
            name: 'AMAllocation',
          }"
          title="Role Configuration"
        >
          <clickable-card
            gotoIcon="mdi-arrow-top-right"
            icon="mdi-account-multiple"
            color="warning"
            cardTitle="AM Allocation"
            style="max-width: 500px;"
          >
          </clickable-card>
        </router-link>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="4"
        >
        <router-link
          :to="{
            name: 'ZMAllocation',
          }"
          title="Role Configuration"
        >
          <clickable-card
            gotoIcon="mdi-arrow-top-right"
            icon="mdi-account-group"
            color="pink"
            cardTitle="ZM Allocation"
            style="max-width: 500px;"
          >
          </clickable-card>
        </router-link>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
// import Utils from '@/utils'
import ClickableCard from '@/components/template/ClickableCard'
// import stores from '@/stores'
export default {
  name: 'roleConfiguration',
  components: { ClickableCard },
  data () {
    return {

    }
  }
}
</script>
<style scoped>
.rowClass {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
